import React, { memo } from "react";

import styled from "styled-components";

import { HeadingProps, Heading as ODSHeading } from "@origin-digital/ods-core";
import { HeadingVariants } from "@origin-digital/ods-types";

const Heading = styled(ODSHeading)(({ theme: { breakpoints }, variant }) => {
  const responsiveFontSize: Record<"h1", any> = {
    h1: {
      [breakpoints.up("lg")]: {
        fontSize: "56px",
        lineHeight: "64px",
      },
      [breakpoints.down("sm")]: {
        fontSize: "24px",
        lineHeight: "32px",
      },
    },
  };
  let responsiveBasekick = {};

  if (variant === "h1") {
    responsiveBasekick = responsiveFontSize[variant!];
  }

  return {
    "&&": {
      marginBottom: "24px",
      whiteSpace: "pre-line",
      verticalAlign: "bottom",
      ...responsiveBasekick,
    },
  } as const;
});

type StyledHeadingProps = Omit<HeadingProps, "variant"> & {
  variant?: HeadingVariants;
};

const StyledHeading = memo(
  ({ id = "", variant = "h2", children, ...restProps }: StyledHeadingProps) => {
    return (
      <>
        <Heading
          id={id}
          data-id={id}
          variant={variant}
          tone="primaryB"
          weight="medium"
          {...restProps}
        >
          {children}
        </Heading>
      </>
    );
  }
);

export { StyledHeading };
